export const EXPIRY_MAIL_PRESETS = [
    { label: '10 days before', days: 10 },
    { label: '7 days before', days: 7 },
    { label: '5 days before', days: 5 },
    { label: '3 days before', days: 3 },
    { label: '1 day before', days: 1 },
    { label: 'On expiry day', days: 0 },
    { label: '3 days after', days: -3 },
    { label: '7 days after', days: -7 },
    { label: '10 days after', days: -10 },
];

export const DEFAULT_TEMPLATE_FORM = {
    name: '',
    emails: [],
    expiryConfig: {
        enabled: true,
        mails: [{ days: 10, enabled: true }]
    }
};
